import React from 'react';
import styles from '../styles/page1.module.css';
import rdcrl from "../../../assets/landing_pageV1/radium_circle.webp";
import Star from "../../../assets/landing_pageV1/Vector.svg";
import dbcomas from "../../../assets/landing_pageV1/inverteddbcomas.svg";
import VinGif from "../../../assets/landing_pageV1/page1_vin.gif";
import { useNavigate } from 'react-router-dom';
import { routesLinks } from "../../../utils/RouteConstants";

const Page1 = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.container}>
            <div className={styles.subContainer}>
                <div className={styles.leftGrid}>
                    <div className={styles.title}>Leading the next chapter in education with</div>
                    <div className={styles.inline}>
                        <span className={styles.aipower}>AI-Powered</span>
                        <img
                            className={styles.star}
                            src={Star}
                            alt="Star"
                            loading="eager"
                            decoding="sync"
                        />
                        <span className={styles.title}>learning</span>
                    </div>
                    <div
                        className={styles.button}
                        onClick={() => { navigate(routesLinks.aboutus) }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                navigate(routesLinks.aboutus);
                            }
                        }}
                    >
                        About Coschool
                    </div>
                </div>
                <div className={styles.rightGrid}>
                    <img
                        src={rdcrl}
                        className={styles.rdcrlImg}
                        alt="Radium Circle"
                    />
                </div>
            </div>
            <div className={styles.vinContainer}>
                <div className={styles.leftVinGrid}>
                    <div className={styles.vinImgContainer}>
                        <img
                            src={VinGif}
                            className={styles.vinImg}
                            alt="Vin AI Tutor Animation"
                        />
                    </div>
                </div>
                <div className={styles.rightVinGrid}>
                    <img
                        src={dbcomas}
                        alt="Quote marks"
                        className={styles.dbcomas}
                    />
                    <div className={styles.topVerticalLine} />
                    <div className={styles.intro}>Hi there!</div>
                    <div
                        className={styles.vinText}
                        dangerouslySetInnerHTML={{ __html: `I'm <span style="color:#604FC7;">Vin,</span>` }}
                    />
                    <div className={styles.vinDesc}>your students' AI Tutor</div>
                    <div className={styles.bottomVerticalLine} />
                    <div className={styles.vinInfo}>I deliver personalised one-on-one tutoring for each student.</div>
                    <div className={styles.vinImgMobile}>
                        <img
                            src={VinGif}
                            className={styles.vinImg}
                            alt="Vin AI Tutor Animation Mobile"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default React.memo(Page1);